<template>
  <modal name="modal-add-time" height="auto" :width="560"
         :scrollable="true" :clickToClose="false" @closed="$emit('input', false)">
    <div class="modal-head mb-3">
      <h4>ADD TIME</h4>
      <a href="javascript:;" class="close" @click="closeModal"></a>
    </div>
    <form method="post" @submit.prevent="doSave">
      <div class="row">
        <div class="form-group col">
          <label>DATE <span class="text-danger">*</span></label>
          <datetime-picker name="session_date" :config="dateOption"
                           :class="{'form-control': true, 'is-invalid': errors.has('session_date')}"
                           v-validate.disable="{ required: true }"
                           v-model="session_date"></datetime-picker>
          <div class="invalid-feedback">{{ errors.first('session_date') }}</div>
        </div>
      </div>
      <div class="row">
        <div class="form-group col">
          <label for="task_id">TASK <span v-if="JOB_TASKS.length" class="text-danger">*</span></label>
          <select name="task_id" class="form-control" id="task_id" v-model="task_id">
            <option value="">- Select -</option>
            <option v-for="task in JOB_TASKS" :key="task.id" :value="task.id">
              {{ task.name }}
            </option>
          </select>
        </div>
      </div>
      <div class="row">
        <div class="form-group col">
          <label>Category</label>
          <v-select v-model="cost_category_id" :options="allCostCategories" class="form-control" :reduce="item => item.id"
                    label="name" :searchable="true" :clearable="false" :placeholder="'- Select category'"></v-select>
        </div>
        <div class="form-group col">
          <label>Cost Item</label>
          <v-select v-model="cost_matrix_id" :options="filteredCostRecords" class="form-control" :reduce="item => item.id"
                    label="description" :searchable="true" :placeholder="'- Select cost item'"></v-select>
          <div class="invalid-feedback">{{ errors.first('cost_matrix_id') }}</div>
        </div>
      </div>
      <div class="row">
        <div class="form-group col">
          <label>START TIME <span class="text-danger">*</span></label>
          <datetime-picker name="start_time" :config="timeOption"
                           :class="{'form-control': true, 'is-invalid': errors.has('start_time')}"
                           v-validate.disable="{ required: true }"
                           v-model="start_time"></datetime-picker>
          <div class="invalid-feedback">{{ errors.first('start_time') }}</div>
        </div>
        <div class="form-group col">
          <label>END TIME <span class="text-danger">*</span></label>
          <datetime-picker name="end_time" :config="timeOption"
                           :class="{'form-control': true, 'is-invalid': errors.has('end_time')}"
                           v-validate.disable="{ required: true }"
                           v-model="end_time"></datetime-picker>
          <div class="invalid-feedback">{{ errors.first('end_time') }}</div>
        </div>
      </div>
      <div class="row">
        <div class="form-group col">
          <label for="break">BREAK (minutes) <span class="text-danger">*</span></label>
          <input type="text" name="name" id="break"
                 :class="{'form-control': true, 'is-invalid': errors.has('break')}"
                 v-validate.disable="{ required: true }"
                 v-model="break_in_minutes">
          <div class="invalid-feedback">{{ errors.first('break') }}</div>
        </div>
        <div class="form-group col">
          <label for="duration">TOTAL TIME <span class="text-danger">*</span></label>
          <input type="text" name="name" id="duration" readonly="readonly"
                 :class="{'form-control': true, 'is-invalid': errors.has('duration')}"
                 v-validate.disable="{ required: true }"
                 v-model="duration">
          <div class="invalid-feedback">{{ errors.first('duration') }}</div>
        </div>
      </div>
      <div class="form-group">
        <label for="description">DESCRIPTION <span class="text-danger">*</span></label>
        <textarea id="description" type="text" class="form-control" rows="2" placeholder="Description"
                  :class="{'form-control': true, 'is-invalid': errors.has('description')}"
                  v-validate.disable="{ required: true }"
                  v-model="description"></textarea>
        <div class="invalid-feedback">{{ errors.first('description') }}</div>
      </div>
      <div class="pt-2 btns btns-2">
        <beat-loader v-if="state == 'saving'"></beat-loader>
        <template v-else>
          <button type="submit" class="btn btn-outline-black mr-2">Submit</button>
          <button type="button" class="btn btn-outline-secondary" @click="closeModal">Cancel</button>
        </template>
      </div>
    </form>
  </modal>
</template>

<script>
  import { mapState, mapGetters } from 'vuex'
  import BeatLoader from 'vue-spinner/src/BeatLoader'
  import dayjs from 'dayjs'
  import ServiceTimesheet from '@/services/timesheet'
  import DatetimePicker from 'vue-bootstrap-datetimepicker'

  export default {
    components: {
      BeatLoader,
      DatetimePicker
    },
    data () {
      return this.initialState()
    },
    props: ['value'],
    computed: {
      ...mapState({
        currentUser: state => state.option.currentUser,
        allCostRecords: state => state.option.costs,
        allCostCategories: state => state.option.costCategories
      }),
      ...mapGetters(['JOB', 'JOB_TASKS']),
      duration: function(){
        let start_time = dayjs('2020-01-01 ' + this.start_time);
        let end_time = dayjs('2020-01-01 ' + this.end_time);
        let d = (end_time.diff(start_time, "minute", 2) - this.break_in_minutes)/60.0;
        return d.toFixed(2);
      },
      filteredCostRecords: function() {
        let self = this, records = [];
        for(let i in self.allCostRecords) {
          if(self.allCostRecords[i].category_id == self.cost_category_id) {
            records.push(self.allCostRecords[i]);
          }
        }
        return records;
      }
    },
    watch: {
      timesheet: 'init',
      value ( newVal ) {
        if ( newVal ) {
          this.$modal.show('modal-add-time', {});
        }
      }
    },
    mounted () {
      this.init();
    },
    methods: {
      initialState (){
        return {
          state: '',
          session_date: '',
          start_time: '',
          end_time: '',
          break_in_minutes: 0,
          description: '',
          dateOption: {
            format: 'DD/MM/YYYY',
            useCurrent: true,
          },
          timeOption: {
            format: 'HH:mm',
            useCurrent: true,
          },
          task_id: '',
          cost_category_id: 1,
          cost_matrix_id: ''
        }
      },
      init () {
        let self = this, now = new Date();
        Object.assign(this.$data, this.initialState());
        self.session_date = dayjs(now).format('DD/MM/YYYY');
        self.start_time = dayjs(now).format('HH:mm');
        self.end_time = dayjs(now).format('HH:mm');
        self.break_in_minutes = 0;
        self.description = '';
      },
      closeModal () {
        this.$modal.hide('modal-add-time');
      },
      doSave ( ) {
        let self = this;

        if ( self.state == 'saving' ) {
          return;
        }

        if (!self.isValid())
          return false;

        self.$validator.validateAll()
          .then(ok => {
            if (ok) {
              let postData = {
                job_id: self.JOB.id,
                user_id: self.currentUser.id,
              };
              postData.cost_matrix_id = self.cost_matrix_id;
              postData.session_date = self.session_date;
              postData.start_time = self.start_time;
              postData.end_time = self.end_time;
              postData.break = self.break_in_minutes;
              postData.description = self.description;
              if (self.task_id)
                postData.task_id = self.task_id;

              self.state = 'saving';
              ServiceTimesheet.create(postData, timesheet => {
                self.state = '';
                self.$notify({
                  type: 'success',
                  text: 'Timesheet added successfully.'
                });
                self.$emit('timesheet-saved', timesheet);
                self.init();
                self.closeModal();
              }, () => {
                self.state = '';
              });
            }
          });
      },
      isValid() {
        let self = this, requiredFields = {
          'description': 'Please enter the description'
        };
        if (self.JOB_TASKS.length) {
          requiredFields['task_id'] = 'Please select the task';
        }
        for(let f in requiredFields) {
          if (!self[f]) {
            self.$notify({
              type: 'error',
              text: requiredFields[f]
            });
            return false;
          }
        }
        return true;
      }
    }
  }
</script>
